import React, { useEffect, useState, useRef } from 'react';
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store"
import { getCategoryList, uploadCategoryVideo, addCategoryVideo } from "../adminSlice";
import { InputField, Submitbtn } from "../../../Component";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import DropdownWithClear from "../../../Component/dropdownWithClear";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { validateAgeGrp } from '../../../Utils/validators';

const AddCategoryVideos = () => {
    const dispatch: Function = useDispatch<AppDispatch>();
    const [categoryList, setCategoryList] = useState<any>([]);
    const [category, setCateogry] = useState<any>();
    const initialVal = [{ videoName: "", order: "", videoUrl: "", videoPreview: "" }];
    const [categoryVideos, setCateogryVideos] = useState<any>(initialVal);
    const videoRef = useRef<HTMLVideoElement | null>(null);
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.load();
        }
    }, [categoryVideos]);
    useEffect(() => {
        dispatch(
            getCategoryList({
                params: {},
                callback: (res: any) => {
                    setCategoryList([...res].sort((a, b) => a?.order - b?.order));
                    if (res?.status === "success") {
                        dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                        setTimeout(() => {
                            hideSnackbar();
                        }, 5000);
                    }
                },
                errorCallback: (error: any) => {
                    dispatch(showSnackbar({ message: error?.data?.msg, type: "error" }));
                    setTimeout(() => {
                        hideSnackbar();
                    }, 5000);
                },
            })
        );
    }, []);
    const onChangeCategory = (value: any) => {
        setCateogry(value);
    };
    const onchangeCategoryVideo = (
        value: any,
        index: number,
        key: string
    ) => {
        const newArray = [...categoryVideos];
        if (key === "videoName") {
            newArray[index][key] = value;
            setCateogryVideos(newArray);
        } else if (key === "order") {
            if (validateAgeGrp(value)) {
                newArray[index][key] = value;
                setCateogryVideos(newArray);
            }
        } else if (key === "video") {
            const MAX_VIDEO_SIZE = 150 * 1024 * 1024;
            const file = value.target.files?.[0];
            if (!file) return;
            if (file.size >= MAX_VIDEO_SIZE) {
                dispatch(
                    showSnackbar({
                        message: "Only videos below 150 MB are allowed.",
                        type: "error",
                    })
                );
                value.target.value = "";

                setTimeout(() => {
                    dispatch(hideSnackbar());
                }, 5000);

                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                newArray[index]["videoPreview"] = reader.result;
                setCateogryVideos([...newArray]);
            };
            reader.readAsDataURL(file);
            dispatch(
                uploadCategoryVideo({
                    params: file,
                    callback: (res: any) => {
                        if (res?.data) {
                            newArray[index]["videoUrl"] = res.data.name;
                            newArray[index]["videoPreview"] = res.data.url;
                            setCateogryVideos([...newArray]);
                            dispatch(
                                showSnackbar({
                                    message: res?.msg,
                                    type: res?.status,
                                })
                            );
                            setTimeout(() => {
                                dispatch(hideSnackbar());
                            }, 5000);
                        }
                    },
                    errorCallback: (error: any) => {
                        dispatch(
                            showSnackbar({
                                message:
                                    error?.data?.msg ||
                                    "Video upload failed. Please try again.",
                                type: error?.data?.status || "error",
                            })
                        );
                        setTimeout(() => {
                            dispatch(hideSnackbar());
                        }, 5000);
                    },
                })
            );
        }
    };

    const onPressAdd = () => {
        setCateogryVideos([...categoryVideos, initialVal[0]]);
    };
    const handleClose = (index: any) => {
        const newArrr = [...categoryVideos];
        if (index > -1) {
            newArrr.splice(index, 1);
        }
        setCateogryVideos(newArrr);
    };

    const handelSubmit = (e: any) => {
        e.preventDefault();
        const updatedVideoArr = categoryVideos.map((item: any) => { const { videoPreview, ...rest } = item; return rest });
        const postData = {
            categoryId: category?._id,
            videoUrls: updatedVideoArr
        };
        dispatch(addCategoryVideo({
            params: postData,
            callback: (res: any) => {
                if (res?.status === "success") {
                    dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                    setTimeout(() => {
                        dispatch(hideSnackbar());
                    }, 5000);
                    setCateogry("");
                    setCateogryVideos(initialVal);
                }
            },
            errorCallback: () => { },
        }))
    };
    const validations = () => {
        if (!category) return true;
        const hasInvalidVideo = categoryVideos.some((item: any) =>
            !item?.videoName ||
            !item?.order ||
            !item?.videoPreview
        );
        return hasInvalidVideo;
    };
    return (
        <div className="panel-content">
            <div className="mb-4 d-flex">
                <PageTitle name={"Add Category Videos "} />
            </div>
            <div className="formDiv">
                <form onSubmit={handelSubmit}>
                    <div className="row bxshadow p-2 borderRadius mb-4 w-25">
                        <div className="col-md-12">
                            <LabelInput labelName={"Select Category"} isRequired />
                            <DropdownWithClear
                                labelName={"Select Category"}
                                setInputText={(value: any) => (onChangeCategory(value))}
                                options={categoryList}
                                value={category}
                            />
                        </div>
                    </div>
                    <div className='d-flex align-items-center'>
                        <LabelInput labelName={"Upload Category Video"} isRequired />
                        <span className="required font12 fw-bold ms-2 mb-2">(Video files larger than 150 MB are not allowed)</span>
                    </div>

                    <div className='row gx-5'>
                        {categoryVideos?.map((item: any, index: number) => (
                            <div className='col-md-6 mb-3' key={index}>
                                <div className="row bxshadow p-2 borderRadius mb-4 position-relative">
                                    <div className="col-md-7 mb-4">
                                        <LabelInput labelName={"Video Name"} isRequired />
                                        <InputField
                                            // key={"ex2"}
                                            placeholder={`Enter Video Name`}
                                            setInputText={(value: any) => onchangeCategoryVideo(value, index, "videoName")}
                                            value={item.videoName}
                                            disabled={category === undefined}
                                        />
                                    </div>
                                    <div className="col-md-4 mb-4">
                                        <LabelInput labelName={"Order number"} isRequired />
                                        <InputField
                                            // key={"ex2"}
                                            placeholder={`Order  No. ${index + 1}`}
                                            setInputText={(value: any) => onchangeCategoryVideo(value, index, "order")}
                                            value={item.order}
                                            maxLength={2}
                                            disabled={category === undefined}
                                        />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <LabelInput labelName={"Select Video"} isRequired />
                                        <div className="d-flex">
                                            <ImagePickerAndViewer
                                                value={item?.videoPreview}
                                                handleChange={(value: any) => (onchangeCategoryVideo(value, index, "video"))}
                                                htmlFor={`video-upload-${index}`}
                                                doctype={"video"}
                                                disabled={category === undefined}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <LabelInput labelName={"Video Preview"} />
                                        <div className="video-thumbnail-holder p-1" style={{
                                            width: "200px",
                                            height: "150px",
                                            border: "solid 1px #000"
                                        }}>
                                            {item?.videoPreview ? (
                                                <video
                                                    ref={videoRef}
                                                    className="videoClass d-flex align-items-center justify-content-center"
                                                    controls muted
                                                    poster="images/my_thumbnail.jpg"
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                    }}
                                                >
                                                    <source src={item?.videoPreview} type="video/mp4" />
                                                </video>
                                            ) : (
                                                <div className="d-flex align-items-center justify-content-center" style={{
                                                    backgroundColor: "#f15822", width: "100%",
                                                    height: "100%",
                                                }}>
                                                    <h5 className='colorWhite fw-500'>No Video Uploaded</h5>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    {index === categoryVideos.length - 1 && (
                                        <div className="col-md-3 mb-3 ms-auto text-end position-relative">
                                            <div className="position-absolute bottom-0 end-0">
                                                <AddMoreBtn handleClick={onPressAdd} />
                                            </div>
                                        </div>
                                    )}
                                    {categoryVideos.length === 1 ? null : (
                                        <div className="col-1 position-absolute end-0 text-end">
                                            <DeleteForeverIcon
                                                className="cursor"
                                                color="error"
                                                fontSize="medium"
                                                onClick={() => handleClose(index)}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="col-md-2 my-3 mx-auto">
                        <Submitbtn name={"Submit"} disabled={validations()} />
                    </div>
                </form>
            </div >
        </div >
    );
}

export default AddCategoryVideos;